import * as firebaseDB from '../firebase/database';
import * as dexieDB from '../dexie/helpers';

const isDexieAvailable = () => typeof window !== 'undefined' && window.electron;

const service = () => (isDexieAvailable() ? dexieDB : firebaseDB);

export const getUserAnalysisList = (...args) => service().getUserAnalysisList(...args);
export const createUserAnalysis = (...args) => service().createUserAnalysis(...args);
export const getUserAnalysisData = (...args) => service().getUserAnalysisData(...args);
export const deleteUserAnalysis = (...args) => service().deleteUserAnalysis(...args);
export const updateAnalysisLastUpdate = (...args) => service().updateAnalysisLastUpdate(...args);
export const setAnalysisActionData = (...args) => service().setAnalysisActionData(...args);
export const updateMultipleNodes = (...args) => service().updateMultipleNodes(...args);
export const saveTelestratorInfo = (...args) => service().saveTelestratorInfo(...args);
export const deleteTelestratorData = (...args) => service().deleteTelestratorData(...args);
export const updateActions = (...args) => service().updateActions(...args);
export const onConnectionChange = (...args) => service().onConnectionChange(...args);
export const getUserPermission = (...args) => service().getUserPermission(...args);
export const getUserBeta = (...args) => service().getUserBeta(...args);
export const getUserWooviCustomer = (...args) => service().getUserWooviCustomer(...args);
export const setUserWooviCustomer = (...args) => service().setUserWooviCustomer(...args);
export const updateAnalysisData = (...args) => service().updateAnalysisData(...args);
export const removeAnalysis = (...args) => service().removeAnalysis(...args);
export const getUserLegacyAccess = (...args) => firebaseDB.getUserLegacyAccess(...args);
export const initializeUserLegacyAccess = (...args) => firebaseDB.initializeUserLegacyAccess(...args);
